import { CSSProperties } from '@mui/styles';
import {  observer } from 'mobx-react';
import React from 'react';

interface IPropsIconeSobrescrito {
    children: any;
    fill?: string;
    esquerda?: boolean;
}


class IconeSobrescrito extends React.Component<React.PropsWithChildren<IPropsIconeSobrescrito>> {


    render() {
        const style = {
            width: '24px',
            height: '24px',
            zoom: '63%',
            position: 'absolute',
            top: '0',
            right: '5px',
            borderRadius: '10px',
            backgroundColor: 'var(--fundo-indicador-minuta, white)',
            fill: this.props.fill ? this.props.fill : 'inherit'
        } as CSSProperties;

        if (this.props.esquerda) {
            style.right = undefined;
            style.left = '5px';
        }

        return (
            <svg style={style} className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" >
                {this.props.children}
            </svg>
        );
    }
}

export default observer(IconeSobrescrito);
